import { render, staticRenderFns } from "./printSocial.vue?vue&type=template&id=88d5b476&"
import script from "./printSocial.vue?vue&type=script&lang=js&"
export * from "./printSocial.vue?vue&type=script&lang=js&"
import style0 from "./printSocial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports